import { Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select } from 'antd'
import moment from 'moment'

interface DormModalProps {
    form: any;
    open: boolean;
    onFinish: (values: any) => void;
    onCancel: () => void;
    genderList?: any[];
}

const DormModal = ({ form, onFinish, open, onCancel, genderList }: DormModalProps) => {

    return (
        <Modal
            title="Dormitory"
            onOk={() => form.submit()}
            open={open}
            destroyOnClose
            width={800}
            onCancel={onCancel}
        >
            <Form
                form={form}
                name="dormitory"
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item
                    label="Id"
                    name="id"
                    hidden
                    noStyle
                >
                    <Input />
                </Form.Item>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            label="Name KZ"
                            name="name"
                            rules={[{ required: true, message: 'Please input the name!' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Name EN"
                            name="nameEn"
                            rules={[{ required: true, message: 'Please input the name en!' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Name RU"
                            name="nameRu"
                            rules={[{ required: true, message: 'Please input the name ru!' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item
                    label="Address"
                    name="address"
                    rules={[{ required: true, message: 'Please input the address!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[{ required: true, message: 'Please input the phone!' }]}
                >
                    <Input />
                </Form.Item>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            label="Type"
                            name="type"
                        // rules={[{ required: true, message: 'Please input the type!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Special Toilets Count"
                            name="specialToiletsCount"
                        // rules={[{ required: true, message: 'Please input the special toilets count!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Gender"
                            name="genderType"
                            rules={[{ required: true, message: 'Please input the gender type!' }]}
                        >
                            <Select>
                                {genderList?.map((gender) => (
                                    <Select.Option key={gender.id} value={gender.id}>
                                        {gender.value}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            label="Start Date"
                            name="startDate"
                            getValueFromEvent={(onChange) => onChange ? moment(onChange).format('YYYY-MM-DD') : null}
                            getValueProps={(i) => ({ value: i ? moment(i) : null })}
                            rules={[{ required: true, message: 'Please input the start date!' }]}
                        >
                            <DatePicker format={"YYYY-MM-DD"} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Repair Date"
                            name="repairDate"
                            getValueFromEvent={(onChange) => onChange ? moment(onChange).format('YYYY-MM-DD') : null}
                            getValueProps={(i) => ({ value: i ? moment(i) : null })}
                            rules={[{ required: true, message: 'Please input the repair date!' }]}
                        >
                            <DatePicker format={"YYYY-MM-DD"} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            label="Square"
                            name="square"
                            rules={[{ required: true, message: 'Please input the square!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="Beds"
                            name="beds"
                            rules={[{ required: true, message: 'Please input the beds!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="Pay Year"
                            name="payYear"
                            rules={[{ required: true, message: 'Please input the pay year!' }]}
                        >
                            <InputNumber prefix="₸" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="Floor Count"
                            name="floorCount"
                            rules={[{ required: true, message: 'Please input the floor count!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            label="Room Count"
                            name="roomCount"
                            rules={[{ required: true, message: 'Please input the room count!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="Ramp Count"
                            name="rampCount"
                            rules={[{ required: true, message: 'Please input the ramp count!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="Lift Count"
                            name="liftCount"
                            rules={[{ required: true, message: 'Please input the lift count!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="Elevator Count"
                            name="elevatorCount"
                            rules={[{ required: true, message: 'Please input the elevator count!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            label="Has Special Toilets"
                            name="hasSpecialToilets"
                            rules={[{ required: true, message: 'Please input the has special toilets!' }]}
                        >
                            <Select>
                                <Select.Option value={true}>Yes</Select.Option>
                                <Select.Option value={false}>No</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Has Parking"
                            name="hasParking"
                            rules={[{ required: true, message: 'Please input the has parking!' }]}
                        >
                            <Select>
                                <Select.Option value={true}>Yes</Select.Option>
                                <Select.Option value={false}>No</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

            </Form>
        </Modal>
    )
}

export default DormModal